(() => {
  if (!('IntersectionObserver' in window)) return;

  const visibleActions = new Set();
  const observedActions = new WeakSet();
  const mobile = window.matchMedia('(max-width: 749px)');
  const update = () => {
    for (const element of visibleActions) {
      if (!element.isConnected) visibleActions.delete(element);
    }
    document.documentElement.classList.toggle(
      'joysons-purchase-in-view',
      mobile.matches && visibleActions.size > 0
    );
  };
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.intersectionRect.height > 0) {
        visibleActions.add(entry.target);
      } else {
        visibleActions.delete(entry.target);
      }
    }
    update();
  });
  const observeActions = (root) => {
    const actions = root.matches?.('.product-form__buttons')
      ? [root]
      : root.querySelectorAll('.product-form__buttons');
    actions.forEach((element) => {
      if (observedActions.has(element)) return;
      observedActions.add(element);
      observer.observe(element);
    });
    update();
  };

  observeActions(document);
  mobile.addEventListener('change', update);
  // Variant changes and quick views can replace purchase controls in place.
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) observeActions(node);
      }
    }
    update();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
